module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/en_okinawa-16530d228ca4f04f4ff913307037d961.jpg";